// extracted by mini-css-extract-plugin
export var box = "_55-1";
export var checkboxRow = "_55-8";
export var checked = "_55-2";
export var descriptionSpacer = "_55-a";
export var disabled = "_55-3";
export var icon = "_55-6";
export var input = "_55-0";
export var labelSpacer = "_55-9";
export var medium = "_55-5";
export var small = "_55-4";
export var text = "_55-7";